// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Wp6","footer":"styles_footer__3sW0D"};